import { defineStore } from 'pinia';
import { createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import { useStoreSsPlayer } from '../softswiss/player';
import { strapi } from '../transport/strapi';
import { useStoreManagers } from './managers';
import type { INotificationGroup, INotificationsStrapiResponse } from '~/types/notifications';

export const useStoreNotificationsGroup = defineStore('notificationsGroup', {
  state: () => ({
    data: [] as INotificationGroup[],
    requestPromise: null as Promise<INotificationsStrapiResponse> | null,
  }),

  getters: {
    notificationsGroup(): INotificationGroup[] {
      return this.data.filter((notif) =>
        notif.groupIds.split(/\n/).some((n) => useStoreSsPlayer().playerGroupIds.includes(n))
      );
    },
  },

  actions: {
    async loadNotifications() {
      if (!this.requestPromise) {
        const populateString = createPopulateString(['buttons']);

        this.requestPromise = strapi()
          .get('notifications-groups', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        const data = response.data.map((item) => {
          const manager = useStoreManagers().managers.find((m) => m.id === item.managerId);

          // @ts-ignore
          item.manager = manager;

          return item;
        }) as INotificationGroup[];

        this.data = data;

        return true;
      } else {
        return false;
      }
    },
    clearStore() {
      this.$reset();
    },
  },
});
